(function ($, Drupal) {
  Drupal.behaviors.featuredPress = {
    attach: function (context, settings) {
      let splideInstance;

      function initSplideIfNeeded() {
        const isMobile = window.innerWidth <= 1024;

        if (isMobile && !splideInstance) {
          splideInstance = new Splide('.splide', {
            // Add any desired Splide options here
            type: 'slide',
            perPage: 1,
            autoplay: true,
            interval: 3000,
            arrows: true,
            pagination: true,
          }).mount();
        } else if (!isMobile && splideInstance) {
          splideInstance.destroy();
          splideInstance = null;
        }
      }

      // Initial check
      initSplideIfNeeded();

      // On resize
      $(window).on('resize', function () {
        initSplideIfNeeded();
      });

      $('.press-page .press-staff-link').on('click', function (e) {
        e.preventDefault();
        var target = $('#press-staff');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 600, function () {
            history.pushState(null, null, '#press-staff');
          });
        }
      });
    }
  };
})(jQuery, Drupal);
